export class WebAtendimentoDemandaRequest {
    nome: string;
    cpf: string;
    idCategoria: string;
    titulo: string;
    dtInicio: string;
    dtFim: string; 
    icNaoLidaAdm: string;
}